import React from 'react';

interface TableShapeProps {
  shape: 'round' | 'rect';
  width: number;
  height: number;
  label: string;
}

/**
 * Visual table element — renders as either a circle or rounded rectangle.
 * Pure presentation component, no interactivity.
 */
export const TableShape: React.FC<TableShapeProps> = ({ shape, width, height, label }) => {
  const shortLabel = label
    .replace('Table ', 'T')
    .replace('Desk ', 'D')
    .replace('Pod ', 'P')
    .replace('Group ', 'G');

  return (
    <div
      className={`
        flex items-center justify-center
        bg-gradient-to-br from-slate-100 to-slate-300
        border-2 border-slate-300
        shadow-lg
        text-slate-600 font-bold text-sm
        select-none pointer-events-none
        ${shape === 'round' ? 'rounded-full' : 'rounded-lg'}
      `}
      style={{ width, height }}
    >
      {shortLabel}
    </div>
  );
};

export default TableShape;
